import React, { useState } from 'react';
import { Button } from "./components/ui/button"
import { Card, CardContent } from "./components/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/ui/tabs"
import { UserCircle, LogOut } from 'lucide-react';
import Home from './pages/Home';
import Reservations from './pages/Reservations';
import Assignments from './pages/Assignements';

const App = () => {
  const [activeTab, setActiveTab] = useState('home');

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Locke-R</h1>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600">Pošte Srpske</span>
            <Button variant="ghost" size="sm" className="flex items-center">
              <UserCircle className="mr-2 h-4 w-4" />
              Profile
            </Button>
            <Button variant="ghost" size="sm" className="flex items-center text-red-600 hover:text-red-700">
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Card className="mb-8">
            <CardContent className="p-0">
              <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
                <TabsList className="w-full justify-start bg-transparent border-b">
                  <TabsTrigger value="home">Home</TabsTrigger>
                  <TabsTrigger value="reservations">Reservations</TabsTrigger>
                  <TabsTrigger value="assignments">Assignments</TabsTrigger>
                  <TabsTrigger value="payments">Payments</TabsTrigger>
                  <TabsTrigger value="reports">Reports</TabsTrigger>
                </TabsList>
                <div className="p-6">
                  <TabsContent value="home">
                    <Home />
                  </TabsContent>
                  <TabsContent value="reservations">
                    <Reservations />
                  </TabsContent>
                  <TabsContent value="assignments">
                    <Assignments />
                  </TabsContent>
                  <TabsContent value="payments">
                    <h2 className="text-2xl font-semibold mb-4">Payments</h2>
                    <p>Payments content goes here.</p>
                  </TabsContent>
                  <TabsContent value="reports">
                    <h2 className="text-2xl font-semibold mb-4">Reports</h2>
                    <p>Reports content goes here.</p>
                  </TabsContent>
                </div>
              </Tabs>
            </CardContent>
          </Card>
        </div>
      </main>

      <footer className="bg-white border-t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center text-sm text-gray-600">
          <p>&copy; 2024 Locke-R. All rights reserved.</p>
          <div className="flex space-x-4">
            <a href="#" className="hover:text-gray-900">Support</a>
            <a href="#" className="hover:text-gray-900">Privacy Policy</a>
            <a href="#" className="hover:text-gray-900">Terms of Service</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;